import React, { Component } from 'react'
import { Select } from 'formik-antd'
import _ from 'lodash'

const { Option, OptGroup } = Select

export default class SelectCompAntd extends Component {
    state = {
        value: {},
    }

    handleChange = value => {
        this.setState({ value: value })

        if(this.props.handleChange !== undefined){
            this.props.handleChange(value)
        }
    }

    buildOptions(data) {
        let groupedOptions = _.groupBy(data, 'group')
        const result = []
        const groupData = []

        _.forEach(groupedOptions, (value, key) => {
            if (!_.isEmpty(key) && key !== 'undefined') {
                result.push(
                    <OptGroup label={key} key={key}>
                        {value.map(d => (
                            <Option key={d.id}>{d.label}</Option>
                        ))}
                    </OptGroup>
                )
                groupData.push({ label: key, id: key })
            } else {
                    value.map(d =>
                        result.push(<Option key={d.id}>{d.label}</Option>)
                    )
            }
        })

        if (!_.isEmpty(groupData)) {
            const groups = (
                <OptGroup label="groups" key="groups">
                    {groupData.map(d => (
                        <Option key={d.id}>{d.label}</Option>
                    ))}
                </OptGroup>
            )
            result.push(groups)
        }

        return result
    }

    render() {
        return (
            <div>
                <Select
                    name={this.props.name}
                    defaultValue={this.props.defaultValue}
                    showSearch={this.props.showSearch}
                    readOnly={this.props.readOnly}
                    placeholder={this.props.placeholder}
                    className={this.props.className}
                    style={this.props.style}
                    mode={this.props.mode}
                    maxTagTextLength={this.props.maxTagTextLength}
                    maxTagCount={this.props.maxTagCount}
                    allowClear={this.props.allowClear}
                    tokenSeparators={this.props.tokenSeparators}
                    onChange={this.handleChange}
                >
                    {this.buildOptions(this.props.data)}
                </Select>
            </div>
        )
    }
}
